import React, { ReactElement } from 'react';
import { Footer as USWDSFooter } from '@ver-uds/uswds-react';
import FooterSection, { FooterSectionProps } from './FooterSection';
import { FooterNav } from './FooterNav';

export interface FooterProps {
  primarySection: ReactElement<FooterSectionProps>;
  secondarySection?: ReactElement<FooterSectionProps>;
  className?: string;
  id?: string;
}

const Footer = ({ primarySection, secondarySection, className, id }: FooterProps): JSX.Element => {
  return (
    <USWDSFooter id={id} className={className} size="slim">
      <div className="ver-footer">{primarySection}</div>
      {secondarySection ? (
        <div className="ver-footer ver-footer--divider">
          {React.cloneElement(secondarySection, { secondary: true })}
        </div>
      ) : null}
    </USWDSFooter>
  );
};

Footer.Section = FooterSection;
Footer.Nav = FooterNav;

export default Footer;
